import React, { ReactElement } from 'react';
import { LoginByVinPageViewProps } from './LoginByVinPageViewProps';
import { Form } from '../../modules/forms/Form';
import { LoginByVinPageFormSchema } from './LoginByVinPageFormSchema';
import { TextInputField } from '../../modules/forms/fields/TextInputField';
import {
  VehicleLookupIdentityStep,
  VehicleLookupStep,
  VehicleLookupSteps,
  VehicleLookupSubmit,
  VehicleLookupVwLayout,
} from '../../modules/login/VehicleLookupVw';

export function LoginByVinPageVwView({ initialFormData, onSubmit }: LoginByVinPageViewProps): ReactElement {
  return (
    <VehicleLookupVwLayout intro="By entering your VIN and ID, we can identify your previous interactions and vehicle service history to provide you with a more personalised customer experience.">
      <Form schema={LoginByVinPageFormSchema} defaultValues={initialFormData} onSubmit={onSubmit}>
        <VehicleLookupSteps>
          <VehicleLookupStep number={1} title="VIN / Chassis number">
            <TextInputField
              name="vin"
              label="VIN / Chassis number"
              placeholder="e.g. WVWZZZ3CZME123456"
              type="text"
              rules={{ max: 17 }}
              trimString
              errorBelow
            />
          </VehicleLookupStep>
          <VehicleLookupIdentityStep />
        </VehicleLookupSteps>
        <VehicleLookupSubmit />
      </Form>
    </VehicleLookupVwLayout>
  );
}
